export const flexHelper = (justifyContent = 'center', alignItems = 'center') => ({
  display: 'flex',
  justifyContent,
  alignItems,
});
